module.exports = __webpack_public_path__ + "assets/d01e2a00ea7a345ffe29d691cc732c5c.jpg";